export enum PostbackType {
  Pending,
  Hold,
  Approved,
  Rejected,
  Trash,
  RevShare,
}
